/*
 * @Description: Description
 * @Author: hexin
 * @Date: 2025-08-05 14:05:01
 * @LastEditTime: 2025-08-05 14:05:01
 */
import en from 'element-ui/lib/locale/lang/en'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: "MI Jelentés Értelmezése",
        train: "Edzésterv vázlat",
        loading: "Betöltés, kérem várjon...",
        loadingError1: "A jelentés betöltése sikertelen",
        loadingError2: "Elnézést a kellemetlenségért. Kérjük, próbálja újra később.",
    },
    // 登录页面
    login: {
        loginAndRegister: 'Regisztráció/Bejelentkezés',
        registerAndLogin: 'Bejelentkezés/Regisztráció',
        userLogin: 'Bejelentkezés',
        title: 'A telefonszám és az e-mail fiók külön kezelendő. Kérjük, válassza ki a megfelelő fióktípust.',
        mobileLogin: 'Mobil',
        emailLogin: 'E-mail',
        email: 'E-mail',
        loginBtn: 'Bejelentkezés',
        autoLogin: 'Automatikus bejelentkezés legközelebb',
        retransmission: 'Újraküldés {item} mp múlva',
        formList: [
            {
                label: 'Kérjük, adja meg a mobilszámát',
                placeholder: 'Ellenőrző kód kérése',
            },
            {
                label: 'Ellenőrző kód',
                placeholder: '',
            },
            {
                label: 'Adja meg az e-mailt',
            },
        ],
        btn: {
            submit: 'Új fiók létrehozása',
            title: 'Kérjük, adjon meg valós adatokat, és töltse ki figyelmesen.',
        },
        rule: {
            phone: {
                requiredMsg: 'Helytelen mobilszám formátum',
                patternMsg: 'A mobilszám nincs regisztrálva. Kérjük, hozzon létre új fiókot.',
            },
            authCode: {
                requiredMsg: 'Hibás ellenőrző kód. Kérjük, próbálja újra.',
            },
            email: {
                requiredMsg: 'Helytelen e-mail formátum',
                patternMsg: 'Az e-mail cím nincs regisztrálva. Kérjük, hozzon létre új fiókot.',
            },
        },
        codeSuccess: 'Az ellenőrző kód elküldve. Kérjük, ellenőrizze.',
        success: 'Sikeresen elküldve',
        error: 'Küldés sikertelen',
        loginSuccess: 'Sikeres bejelentkezés',
        account: {
            accountTitle: 'Bejelentkezés',
            registerTitle: 'Regisztráció',
            resetTitle: 'Jelszó beállítása',
            password: 'Jelszó',
            placeholder: 'Kérjük, adja meg a jelszavát',
            codeLogin: 'Bejelentkezés ellenőrző kóddal',
            accountLogin: 'Bejelentkezés jelszóval',
            forgotPassword: 'Elfelejtette a jelszavát?',
            registerTips:[
                'Még nincs fiókja?', 
                'Regisztráció', 
                'A fiók már létezik',
                'Regisztrálj most',
            ],
            checkRule: [
                '8-20 karakter',
                'Legalább egy nagybetű',
                'Legalább egy kisbetű',
                'Legalább egy szám', 
                'A jelszavak nem egyeznek'
            ],
            errorTips: [
                'Hibás jelszó', 
                'Sikertelen bejelentkezés', 
                'A fiók nem létezik'
            ],
            reset:[
                'Jelszó visszaállítása', 
                "Következő",
                'Az új jelszó nem lehet ugyanaz, mint a régi', 
                'Kihagyás',
                'A jelszó sikeresen beállítva'
            ],
            setPasswordTips:'A jelszónak 8–20 karakter hosszúnak kell lennie, és tartalmaznia kell nagybetűt, kisbetűt és számot.',
            confirmPassword: "Jelszó megerősítése",
        },
        switchButton: 'Jelszavas bejelentkezés',
        switchButton1: 'Bejelentkezés ellenőrző kóddal',
        loginTips: 'A nem regisztrált fiókok sikeres bejelentkezés után automatikusan regisztrálásra kerülnek.',
        otherLogin: 'Egyéb bejelentkezési módok',
        newEmailLogin: 'Bejelentkezés e-mail címmel',
        newPhoneLogin: 'Bejelentkezés telefonszámmal',
        bindLineTips:'Vagy',
        bindEmail: 'Bejelentkezés összekötött e-mail címmel',
        bindPhone: 'Bejelentkezés összekötött telefonszámmal',
        bindAndContinue: "Összekapcsolás és folytatás",
        bind: "Összekapcsolás",
        bindEmailTitle: 'E-mail összekapcsolása',
        bindEmailTips1: "{item} e-mail infó nem található",
        bindEmailTips2: "A folytatáshoz kapcsolja össze e-mailjét",
        bindEmailTips3: "Nincs e-mail összekapcsolva. Összekapcsolás után beléphet és jelszót kérhet.",
        boundTitle: 'Regisztrált már korábban?',
        boundCenterTitle1:'Ha Ön új felhasználó',
        boundCenterTips1:'Hozzon létre fiókot a kezdéshez',
        boundCenterTitle2:'Ha már van fiókja',
        boundCenterTips2:'Adatok szinkronizálásához kapcsolja össze',
        boundCenterTips3:'Veuillez lier un compte enregistré',
        boundCenterTips4:'Ajánlott',
        boundCenterTips5:'{item} fiók összekapcsolása meglévővel',
        boundCenterTips6:'Az adatok és jelentések szinkronizálódnak',
        boundButton1: 'Fiók létrehozása ezzel: {item}',
        boundButton2: 'Meglévő fiók összekapcsolása',
        phoneCode:"Belépés SMS kóddal",
        phonePassword:"Belépés telefonszámmal",
        emailCode:"Belépés e-mail kóddal",
        emailPassword:"Belépés e-maillel",
        accountDoesNotExist:"Ez a fiók még nincs regisztrálva. Kérjük, regisztráljon e-mail ellenőrző kóddal vagy {item} fiókkal.",
        toRegister:"Regisztráció",
        bindNow: "Összekapcsolás most",
        bindError:[
            'Összekötés sikertelen',
            'Összekötés feloldva',
            'Az összekötés feloldása sikertelen',
            'Engedélyezés sikertelen',
            'Engedélyezés sikertelen, a fiók adatai nem kérhetők le.',
            'Összekötés sikeres',
            'A fiók nem létezik. Kérjük, kössön össze egy regisztrált fiókkal.',
            'Összekötés sikertelen. Ez a fiók már össze van kötve ezzel: {item} [{nickname}].',
            'Fiókként engedélyezve és regisztrálva, a leválasztás nem támogatott',
            'A fiók nem létezik, kérjük, használja a megerősítő kódot a bejelentkezéshez és a regisztrációhoz',
        ],
        accountSecurity: {
            faceBook:'Facebook-fiók',
            google: 'Google-fiók',
            isBind: 'Nincs összekötve',
            dialogTitle: 'Biztosan feloldja az összekötést?',
            dialogCenter: 'A(z) {item} összekötésének feloldása után nem fogja tudni többé használni a bejelentkezéshez.',
            bindFailure:'Összekötés sikertelen',
            bindFailureTips: 'A(z) {item} fiókja már össze van kötve az alábbi fiókkal. Ha a jelenlegi fiókjához szeretné kötni, kérjük, jelentkezzen be az alábbi fiókba, és oldja fel az összekötést.',
            returnButton:'Megerősítés és visszatérés'
        },
        bindEmailError: [
            "Az e-mail már létezik."
        ],
    },
    // 注册页面
    register: {
        mobileRegister: 'Regisztráció mobillal',
        emailRegister: 'Regisztráció e-maillel',
        enroll: 'A mobilszám már regisztrálva van.',
        enrollEmail: 'Ez az e-mail cím már regisztrálva van.',
        search: 'Keresés',
        title: 'A telefonszám és az e-mail fiók külön kezelendő. Kérjük, válassza ki a megfelelő fióktípust.',
        needRead: {
            agree: 'Elolvastam és elfogadom',
            privacy: 'a Felhasználói Adatvédelmi Szabályzatot',
        },
        register: 'Regisztráció',
        check: 'Jelölje be a "Felhasználói Adatvédelmi Szabályzatot"',
        newUser: 'Új felhasználó regisztrációja',
        form: {
            labelList: ['Név', '* Nem', '* Magasság', '* Életkor'],
        },
        placeholder: ['Kérjük, adja meg a nevét', 'Kérjük, adja meg a magasságát', 'Kérjük, adja meg az életkorát'],
        unit: ['Metrikus', 'Angolszász', 'éves'],
        sexOptions: {
            male: 'Férfi',
            female: 'Nő',
        },
        btn: 'Küldés',
        rules: {
            metricheight: ['A megengedett magasságtartomány 2ft3in–6ft7in. Kérjük, adja meg újra.'],
            heightMsg: ['A megengedett magasságtartomány 70–200 cm. Kérjük, adja meg újra.'],
            ageMsg: ['A megengedett korhatár 10–99 év. Kérjük, adja meg újra.'],
            agePointMsg: ['Helytelen adat: az életkornak egész számnak kell lennie. Kérjük, adjon meg érvényes életkort.'],
        },
        success: 'Sikeres regisztráció.',
        userMessage: 'Kérjük, adja meg a felhasználónevét',
        verify: 'Kérjük, adja meg a 4 jegyű ellenőrző kódot',
        errorMsg: 'A magasság formátuma csak egész szám lehet. Kérjük, adja meg újra.',
        abnormalMsg: 'Regisztrációs hiba',
    },
    // 模型合成
    model: {
        loading: 'Modell generálása, kérjük várjon',
        modelLoading: 'Modell betöltése...',
        tabPane: [
            {
                title: 'Mélyérzékelési technológia',
                msg: 'A 3D szkennelés pontosan rögzíti a test részleteit, hogy milliméteres pontosságú körmérést biztosítson, így a fitnesz utáni testváltozások tisztán láthatóvá válnak.',
            },
            {
                title: 'BDA Testösszetétel Algoritmus',
                msg: 'A Visbody a fejlett BDA rendszert használja a testösszetétel meghatározására, amely térfogat-alapú értékelést kínál az elhízásból eredő egészségügyi kockázatok pontosabb felmérésére.',
            },
            {
                title: 'Lehetséges hibaforrások',
                msg: 'A laza ruházat vagy idegen tárgyak hibákat okozhatnak. A legpontosabb eredmények érdekében viseljen szűk ruhát vagy csökkentse a felsőruházatot.',
            },
            {
                title: 'Belépés a jelentéshez',
                msg: 'Javasoljuk, hogy tegye a könyvjelzők közé az oldalt a későbbi hozzáférés érdekében. Ezt a jelentést e-mailben is elküldheti.',
            },
        ],
        collect: ['Kérjük, tegye könyvjelzők közé ezt az oldalt.', 'Hogy később könnyen hozzáférhessen a jelentéshez.'],
        know: 'Értettem',
        reminder: [
            'Barátságos emlékeztető',
            'A 3D-modellje elkészült. Próbálja meg elhúzni a forgatáshoz.',
            'A jelentése elkészült. A megtekintéséhez kattintson a "Jelentés megtekintése" gombra.',
            'A testtartás értékelése sikertelen. Kérjük, tekintse meg a testösszetétel jelentést.',
            'A testösszetétel sikertelen. Kérjük, tekintse meg a testtartás értékelési jelentést.',
            'A mérés sikertelen. Kérjük, próbálja újra az eszközön.',
            'A testösszetétel sikertelen. Kérjük, próbálja újra az eszközön.',
            'A testtartás értékelése sikertelen. Kérjük, próbálja újra az eszközön.',
        ],
        btn: {
            viewReport: 'Jelentés megtekintése',
            bodyReport: 'Testösszetétel-jelentés megtekintése',
            postureReport: 'Testtartás-jelentés megtekintése',
            lastReport: 'Előző jelentés megtekintése',
            loading: 'Betöltés...',
        },
    },
    // 报告
    report: {
        btn: {
            download: 'Jelentés letöltése',
            send: 'Jelentés küldése',
            report: 'Jelentés',
        },
        reportSuccess: 'A jelentés sikeresen legenerálva',
        tabPane: {
            labelList: ['Mérés ideje', 'Tétel', 'Testösszetétel', 'Testtartás értékelése', 'Vállfunkciók'],
        },
        sendEmail: 'Küldés e-mailre:',
        requiredMsg: 'Kérjük, adja meg az e-mail címét',
        patternMsg: 'Kérjük, adjon meg érvényes e-mail címet',
        send: 'Küldés',
        download: 'Jelentés letöltése',
        sendReport: 'Jelentés küldése',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: 'A nem sikeresen frissítve',
            height: 'A magasság sikeresen frissítve',
            age: 'Az életkor sikeresen frissítve',
        },
        logOut: 'Kijelentkezés',
        personal: 'Profilközpont',
        cut: 'Mértékegységek/Nyelv váltása',
        changeSort: 'Termékjelentés váltása',
        setPassword: 'Jelszó beállítása/módosítása',
        describe: '* A termékmodell váltása után az összes kapcsolódó jelentés megjelenik.',
        describeBtn: 'A termékmodell váltása után átirányítjuk a legújabb jelentéshez.',
        descReport: 'A termékjelentés sikeresen átváltva',
        unit: ['Metrikus (kg, cm)', 'Angolszász (ft, in, lb)'],
        read: {
            reading: 'Olvasd el',
            privacy: 'a Felhasználói Adatvédelmi Szabályzatot',
        },
        setting: 'Beállítások',
        form: {
            labelList: ['Mobilszám', 'Mértékegységek', 'Nyelv', 'Becenév', 'Nem', 'Magasság', 'Életkor'],
        },
        placeholder: ['Becenév módosítása', 'Nem módosítása', 'Magasság módosítása', 'Életkor módosítása'],
        btn: {
            cancelBtn: 'Mégse',
            accomplishBtn: 'Kész',
            confirmBtn: 'Megerősítés',
        },
        dialog: [
            'A nem fontos tényező a testösszetétel elemzésében. Módosítása befolyásolhatja a múltbeli adatokkal való összehasonlítást. Megerősíti a módosítást?',
            'A magasság fontos tényező a testösszetétel elemzésében. Módosítása befolyásolhatja a múltbeli adatokkal való összehasonlítást. Megerősíti a módosítást?',
            'Az életkor fontos tényező a testösszetétel elemzésében. Módosítása befolyásolhatja a múltbeli adatokkal való összehasonlítást. Megerősíti a módosítást?',
        ],
        rules: {
            metricheight: ['Kérjük, adjon meg egy magasságot a tartományon belül (2ft3in–6ft7in)'],
            heightMsg: ['Kérjük, adjon meg egy magasságot a tartományon belül (70–200cm)'],
            ageMsg: ['Kérjük, adjon meg egy életkort a tartományon belül (10–99 év)'],
        },
        heightMsg: 'Kérjük, válassza ki újra a magasságot',
        ageMsg: 'Kérjük, válassza ki újra az életkort',
        ModelBinding: 'Úgy tűnik, valaki előbb olvasta be a kódot. Kérjük, mérje meg újra.',
        ReportEmpty: {
            title: 'Még nincsenek kapcsolódó jelentései',
            desc: 'Keresse meg a Visbody 3D Scannert és végezzen egy mérést!',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: 'Úgy tűnik, valaki előbb olvasta be a kódot. Kérjük, mérje meg újra.',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: 'Még nincsenek kapcsolódó jelentései',
        desc: 'Keresse meg a Visbody 3D Scannert és végezzen egy mérést!',
        descS30: 'Keresse meg a Visbody-S30 3D Scannert és végezzen egy mérést!',
        descM30: 'Keresse meg a Visbody-M30 3D Scannert és végezzen egy mérést!',
    },
    // 用户信息
    userInfo: {
        height: 'Magasság:',
        age: 'Életkor:',
        unit: 'éves',
        weight: 'Súly',
    },
    // 体成分
    mass: {
        title: 'Testösszetétel Áttekintés',
        titles: 'Testösszetétel',
        springFrame: '',
        massFrame: 'Nincs mai mérési adat',
        contrast: 'Jelentés összehasonlítás',
        contrastReport: 'Válasszon ki egy összehasonlító jelentést',
        noRecord: 'Nincs rögzítve',
        score: 'pont',
        status: 'Az Ön jelenlegi testösszetételi állapota',
        WT: 'Súly',
        PBF: 'Testzsír Százalék',
        endSymbol: '。',
        // 测量相关
        measure: {
            value: 'Mért értékek',
            standardRange: 'Normál tartomány',
            comparedWithLastLime: 'Változás',
            comparedNet: 'Változás',
            current: 'Jelenlegi mérés pontszáma',
            WT: 'Súly',
            FFM: 'Zsírmentes testtömeg',
            BFM: 'Testzsír tömeg',
            LM: 'Izomtömeg',
            TBW: 'Teljes testvíz',
            SM: 'Vázizom',
            PROTEIN: 'Fehérje',
            TM: 'Szervetlen sók',
            BMR: 'Alapanyagcsere',
            WHR: 'Derék-csípő Arány',
            BMI: 'BMI',
            PBF: 'Testzsír Százalék',
            VFG: 'Zsigeri zsír Szint',
            unit: 'kg',
            BMRUnit: 'kcal/nap',
        },
        // 定义解读
        explain: [
            {
                title: 'Súly',
                msg: 'A testsúly a testvíz, fehérje, szervetlen sók és testzsír összege.',
            },
            {
                title: 'Zsírmentes testtömeg',
                msg: 'A zsírmentes testtömeg a teljes testsúly zsírtartalom nélkül.',
            },
            {
                title: 'Testzsír tömeg',
                msg: 'A testzsír a bőr alatti, a zsigeri és az izmok közötti zsír összege.',
            },
            {
                title: 'Izomtömeg',
                msg: 'Az izomtömeg a sovány testszövetek csoportját jelenti, beleértve a váz-, sima- és szívizmot.',
            },
            {
                title: 'Teljes testvíz',
                msg: 'A testvíz a testsúly 50-70%-át teszi ki. Főként sejtekben és folyadékokban található, leginkább izomsejtekben.',
            },
            {
                title: 'Vázizom',
                msg: 'A vázizom, más néven harántcsíkolt izom, a csontokhoz tapad. Ez a mennyiségét mutatja.',
            },
            {
                title: 'Fehérje',
                msg: 'A fehérje egy nitrogéntartalmú szilárd anyag, amely minden sejtben jelen van, és az izomtömeg egyik fő összetevője.',
            },
            {
                title: 'Szervetlen sók',
                msg: 'A szervetlen sók a testsúly körülbelül 5%-át teszik ki.',
            },
            {
                title: 'Alapanyagcsere',
                msg: 'A BMR az az összes energia, amelyet a test egy nap alatt éber és nyugalmi állapotban, mozgás, étel vagy hőmérséklet által nem befolyásolva fogyaszt.',
            },
            {
                title: 'Derék-csípő Arány',
                msg: 'A derék-csípő arány (WHR) a centrális elhízás értékelésének fontos mutatója.',
            },
            {
                title: 'BMI',
                msg: 'A BMI-t az elhízás felmérésére használják, és általános nemzetközi szabvány.',
            },
            {
                title: 'Testzsír Százalék',
                msg: 'A testzsír százalék a zsír arányát jelenti a teljes testsúlyban.',
            },
            {
                title: 'Zsigeri zsír Szint',
                msg: 'A zsigeri zsírszint fontos mutatója a rejtett elhízás felmérésének.',
            },
            {
                title: 'Sejten belüli folyadék (ICW)',
                msg: 'Sejten belüli folyadék: a sejteken belüli folyadék, a protoplazma alapvető része.',
            },
            {
                title: 'Sejten kívüli folyadék (ECW)',
                msg: 'Sejten kívüli folyadék: a sejteken kívüli folyadék, beleértve a plazmát és az intersticiális folyadékot.',
            },
            {
                title: 'Anyagcsere-életkor',
                msg: 'Az anyagcsere-életkor a test és az egészséggel kapcsolatos anyagcsere-funkciók teljesítményét jelenti.',
            },
            {
                title: 'ECW/TBW arány',
                msg: 'Az ECW/TBW arány az extracelluláris víz (ECW) aránya a szervezet teljes víztartalmán (TBW) belül. Fontos mutató a test folyadékháztartásának értékeléséhez.',
            },
        ],
        // 节段
        segment: {
            fat: 'Szegmentális zsír',
            muscle: 'Szegmentális izom',
            right: 'Jobb',
            left: 'Bal',
            standard: 'Normál',
            lowStandard: 'Alatti',
            superStandard: 'Feletti',
            peel: '(Tára)',
        },
    },
    // 体态
    shape: {
        title: 'Testtartás Értékelés Áttekintés',
        titles: 'Testtartás',
        status: 'Az Ön jelenlegi testtartási állapota',
        suggest: 'Javaslat',
        possibility: ', mutatja',
        models: {
            front: 'Elülső',
            left: 'Bal oldal',
            right: 'Jobb oldal',
            top: 'Hátulnézet',
            low: 'Átlag alatti',
            high: 'Átlag feletti',
            normal: 'Normális',
        },
        item: {
            deviate: 'Mért értékek',
            result: 'Leírás',
            normal: 'Normális',
            abnormal: 'Rendellenes',
            keAbnormal: 'Lehetséges rendellenesség',
            head: 'Előrehelyezett fejtartás',
            headSlant: 'Fejdőlés',
            roundShoulderLeft: 'Előre gördült váll (bal oldal)',
            roundShoulderRight: 'Előre gördült váll (jobb oldal)',
            highLowShoudler: 'Egyenetlen vállak',
            pelvis: 'Medence előre/hátra billenés',
            leftKneeCheck: 'Bal térd értékelése',
            rightKneeCheck: 'Jobb térd értékelése',
            leg: 'Lábtípus',
            leftLeg: 'Bal láb:',
            rightLeg: 'Jobb láb:',
        },
        // 定义解读
        explain: [
            {
                title: 'Előrehelyezett fejtartás',
                msg: 'A fülpont és a nyak közepe közötti vonal, valamint az oldalsó középvonal szöge a bal oldalon',
            },
            {
                title: 'Fejdőlés',
                msg: 'A fej középvonala és a nyak közepe közötti vonal, valamint az elülső középvonal szöge',
            },
            {
                title: 'Előre gördült váll (bal oldal)',
                msg: 'A hát bal oldalának legmagasabb pontja és a váll érintője közötti szög',
            },
            {
                title: 'Előre gördült váll (jobb oldal)',
                msg: 'A hát jobb oldalának legmagasabb pontja és a váll érintője közötti szög',
            },
            {
                title: 'Egyenetlen vállak',
                msg: 'A bal és jobb vállcsúcs függőleges távolsága a háton',
            },
            {
                title: 'Medence előre/hátra billenés',
                msg: 'A nyak, a csípő és a boka pontjai közötti szög a bal oldali nézetben',
            },
            {
                title: 'Bal térd értékelése',
                msg: 'A csípő, a térd és a boka közötti szög a bal oldali nézetben',
            },
            {
                title: 'Jobb térd értékelése',
                msg: 'A csípő, a térd és a boka közötti szög a jobb oldali nézetben',
            },
            {
                title: 'Lábtípus',
                msg: 'Mindkét láb esetén elölnézetből mért csípő–térd–boka szög',
            },
        ],
        exception: [
            {
                title: 'Balra tolódott',
                abnormal: '',
            },
            {
                title: 'Jobbra tolódott',
                abnormal: '',
            },
            {
                title: 'Bal magasabban',
                abnormal: '',
            },
            {
                title: 'Jobb magasabban',
                abnormal: '',
            },
            {
                title: 'Hátrabillent medence',
                abnormal: '',
            },
            {
                title: 'Előre tolódott medence',
                abnormal: '',
            },
            {
                title: 'Bal térd hiperextenzió',
                abnormal: '',
            },
            {
                title: 'Bal térd flexió',
                abnormal: '',
            },
            {
                title: 'Jobb térd hiperextenzió',
                abnormal: '',
            },
            {
                title: 'Jobb térd flexió',
                abnormal: '',
            },
            {
                title: 'K-láb típus',
                abnormal: '',
            },
            {
                title: 'D-láb típus',
                abnormal: '',
            },
            {
                title: 'X-láb típus',
                abnormal: '',
            },
            {
                title: 'O-láb típus',
                abnormal: '',
            },
            {
                title: 'Medence Előrebillenése',
                abnormal: ''
            },
            {
                title: 'Medence Hátrabillenése',
                abnormal: ''
            },
            {
                title: 'Kóros bal lábhossz',
                abnormal: ''
            },
            {
                title: 'Kóros jobb lábhossz',
                abnormal: ''
            }
        ],
    },
    newshape: {
        explain: [
            {
                msg: 'A fül és a test súlyvonala közötti függőleges távolság',
            },
            {
                msg: 'A füleket összekötő vonal és a vízszintes vonal közötti szög',
            },
            {
                msg: 'A bal vállcsúcs és a súlyvonal közötti függőleges távolság',
            },
            {
                msg: 'A jobb vállcsúcs és a súlyvonal közötti függőleges távolság',
            },
            {
                msg: 'A nyak töve és a vállcsúcs vonala közötti különbség (bal és jobb)',
            },
            {
                msg: 'A csípőízület és a test súlyvonala közötti függőleges távolság',
            },
            {
                msg: 'A boka, a bal térd alatt 1 cm-re lévő pont és a csípő közötti szög (szagittális sík)',
            },
            {
                msg: 'A boka, a jobb térd alatt 1 cm-re lévő pont és a csípő közötti szög (szagittális sík)',
            },
            {
                msg: 'A bal/jobb csípő, térd és boka közötti szög (koronális sík)',
            },
        ],
        item: {
            pelvis: 'Előre tolódott medence',
        },
    },
    // 围度信息
    girth: {
        title: 'Testkörfogat',
        present: '(most)',
        noHistory: 'Nincs adat',
        tpl: [
            {
                title: 'Nyak kerülete',
                key: 'neckGirth',
            },
            {
                title: 'Bal felkar kerülete',
                key: 'leftUpperArmGirth',
            },
            {
                title: 'Jobb felkar kerülete',
                key: 'rightUpperArmGirth',
            },
            {
                title: 'Mellbőség',
                key: 'bustGirth',
            },
            {
                title: 'Magas derékbőség',
                key: 'waistGirth',
            },
            {
                title: 'Közép derékbőség',
                key: 'midWaistGirth',
            },
            {
                title: 'Csípőbőség',
                key: 'hipGirth',
            },
            {
                title: 'Bal comb kerülete',
                key: 'leftThighGirth',
            },
            {
                title: 'Bal comb középső kerülete',
                key: 'leftMidThighGirth',
            },
            {
                title: 'Bal comb legkisebb kerülete',
                key: 'leftMinThighGirth',
            },
            {
                title: 'Jobb comb kerülete',
                key: 'rightThighGirth',
            },
            {
                title: 'Jobb comb középső kerülete',
                key: 'rightMidThighGirth',
            },
            {
                title: 'Jobb comb legkisebb kerülete',
                key: 'rightMinThighGirth',
            },
            {
                title: 'Bal lábszár kerülete',
                key: 'leftCalfGirth',
            },
            {
                title: 'Jobb lábszár kerülete',
                key: 'rightCalfGirth',
            },
            {
                title: 'Alacsony derék',
                key: 'lowWaistGirth',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: 'Vállfunkciók',
        model: {
            val: 'Mért értékek',
            scope: 'Maximális aktivitási hely',
            diff: 'Változás',
        },
        normal: 'Az értékelés során nem találtak nyilvánvaló rendellenességet',
        normalAll: 'A vállfunkcióban nem találtak nyilvánvaló rendellenességet',
        conclusion: 'Következtetés',
        analyse: 'Elemzés:',
        suggest: 'Javaslat: ',
        cause: 'A pontos okokért kérjük, forduljon szakemberhez további vizsgálat céljából.',
    },
    reportTips: {
        title: "Biztosan törölni szeretné a jelentést? A törlés után nem lehet visszaállítani.",
        confirm: "Törlés",
        success: "A jelentés törölve lett.",
        partial: "A jelentés törölve lett, de bizonyos adatok szinkronizálása sikertelen volt. Kérjük, forduljon az adminisztrátorhoz.",
        failed: "Törlés sikertelen, kérjük, próbálja újra később.",
        btnMsg: 'OK',
        alaryTips: 'Ezt a jelentést az adminisztrátor törölte. Átirányítás a következő jelentésre.',
    },
    saveQr: {
        title: 'Visbody 3D Testjelentés',
        btnMsg: 'Hosszan nyomja meg a képet a telefonra mentéshez',
        tips: 'Ha nem tud menteni, kérjük, engedélyezze a jogosultságokat a [Beállítások] menüpontban',
    },
    share: {
        title: 'Kérjük, másolja az alábbi linket a megosztáshoz',
        btnMsg: 'Másolás',
    },
    'bodyPrediction': {
        'body-title': '体型预测',
        'body-yu-ce-status': '根据您当前状态预测',
        'body-setting': '体型预测设置',
        'body-li-xiang': '理想值：',
        'body-ti-zhong': 'Súly',
        'body-ti-zhi-lv': 'Testzsír Százalék',
        'body-ji-rou': '肌肉含量',
        'yu-che-pre': '预测前',
        'yu-che-after': '预测后',
        'zan-model-no': '暂无模型',
        'ti-xing-error': '体型预测结果合成失败~',
        'ti-xing-worker-error': '小编猜测可能是网络原因导致的~',
        'ti-xing-adjust': '调节量',
        'ji-rou-title': 'Izomtömeg',
        'ti-zi-fang': 'Testzsír tömeg',
        'dang-pre-zhi': '当前值：',
        'nen-zhang': 'Zsigeri zsír Szint',
        'nen-zhang-title': '内脏脂肪面积说明',
        'nen-zhang-title1': '内脏脂肪分布在内脏器官之间得脂肪，易导致腹部肥胖，内脏脂肪面积显示的是内脏脂肪横截面积。'
    },
     ...en,
    ...agrEn,
    wifi: {
        'title': 'WiFi配置',
        'tips': '请输入以下 WiFi 网络的密码',
        'password':'WIFI 密码',
        'password-placeholder': '请输入 WiFi 密码',
        'password-tips': '密码区分大小写，请确保输入正确',
        'button': '生成二维码',
        'h5-title': '配置WIFI信息',
        'wifi-name': 'WIFI名称:',
        'wifi-password': 'WIFI密码:',
        'wifi-qr-tips1': '* 请确认 WiFi 名称和密码无误后，对准设备屏幕下方的相机位置进行扫描。',
        'wifi-qr-tips2': '请将 WiFi 二维码对准屏幕下方的相机位置进行扫描。',
        'wifi-qr-button': '返回',
    },
    "waist": {
        "title": "Derék- és hasbőség",
        "hou": "Hátul",
        "qian": "Elöl"
    },
    "yao_wei_1": "Derék",
    "yao_bu_fen_shu": "Derékpontszám",
    "waist_fen": "pont",
    "yao_wei": "Derékkörfogat",
    "yao_wei_jian_ti_ji": "Térfogat a derékvonalak között",
    "yao_tun_bi": "Derék-csípő Arány",
    "lun_kuo_fen_xi": "Kontúrelemzés",
    "bei_bu": "Hátrész",
    "tunbu": "Fenéktájék",
    "bei_bu_ti_ji": "Háttérfogat",
    "zheng_chang_fan_wei": "Normál tartomány:",
    "shang_ci": "Előző ",
    "ben_ci": "Most ",
    "gupen": {
        "zheng_chang": "Normál",
        "qian_qin_yan_chang": "Kóros előrebillenés",
        "qian_qin_yi": "Előrebillenési kockázat",
        "hou_qin_yi": "Hátrabillenési kockázat",
        "hou_qin_yan_chang": "Kóros hátrabillenés",
        "zuo_chang_yan_chang": "Kóros bal lábhossz",
        "zuo_chang_yi": "Bal lábhossz kockázata",
        "you_chang_yi": "Jobb lábhossz kockázata",
        "you_chang_yan_chang": "Kóros jobb lábhossz"
    },
    "gao_yao_xian": "Magas derékbőség",
    "gao_yao_zhong_xian": "Magas Derék Középvonala",
    "gao_yao_xia_xian": "Magas Derék Alsó Vonala",
    "xiao_yao_shang_xian": "Alacsony Derék Felső Vonala",
    "xiao_yao_zhong_xian": "Alacsony Derék Középvonala",
    "xiao_yao_xian": "Alacsony derék",
    "qv_jian1": "Magas derék felső szakasza",
    "qv_jian2": "Magas derék alsó szakasza",
    "qv_jian_zhong": "Közép-derék szakasz",
    "qv_jian3": "Alacsony derék felső szakasza",
    "qv_jian4": "Alacsony derék alsó szakasza",
    "celiang.failed": "A mérés sikertelen volt. Kérjük, viseljen testhezálló ruházatot, és maradjon mozdulatlan a mérés során.",
    "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Kifejezett fej dőlés/előrehelyezés enyhe nyaki eltéréssel. Figyeljen az ülésmódra.",
    "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Fej dőlés/előrehelyezés nyaki eltéréssel. Tartáskontroll és edzés javasolt.",
    "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Jelentős fej dőlés és nyaki eltérés. Szakértői felmérés javasolt.",
    "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Enyhe háti eltérés. A tartáskontroll javítása javasolt.",
    "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "A háti eltérés rontja a stabilitást. Célzott edzés javasolt.",
    "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Jelentős háti eltérés és aszimmetria. Szakértői korrekció javasolt.",
    "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Enyhe ágyéki eltérés, kiegyensúlyozott tartás. Törzsstabilizáció javasolt.",
    "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Az ágyéki eltérés rontja a stabilitást. Korrekciós edzés javasolt.",
    "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Jelentős ágyéki eltérés. Szakértői javítási terv javasolt.",
    "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "Hipertónia: m. levator scapulae, SCM, felső trapéz. Gyengeség: mély nyaki hajlítók. Stabilizáció és lazítás javasolt.",
    "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hipertónia: bal SCM és hátsó scalenus. Gyengeség: jobb SCM. Kétoldali egyensúly és lazítás javasolt.",
    "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hipertónia: jobb SCM. Gyengeség: bal SCM és hátsó scalenus. Szimmetrikus stabilizáció és lazítás javasolt.",
    "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hipertónia: bal felső trapéz. Gyengeség: középső/alsó trapéz. Edzés (középső/alsó) és lazítás javasolt.",
    "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "Hipertónia: csípő befelé forgatók és adduktorok. Gyengeség: m. gluteus medius. Gluteus edzés és nyújtás javasolt.",
    "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "Hipertónia: m. gluteus medius és piriformis. Gyengeség: adduktorok, befelé forgatók, LCL. Láb stabilizáció és farizom lazítás javasolt.",
    "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Hipertónia: m. gluteus medius és piriformis. Féloldali gyengeség: adduktorok, befelé forgatók, LCL. Kétoldali edzés javasolt.",
    "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hipertónia: bal hamstring és m. popliteus. Gyengeség: m. quadriceps és soleus. Quadriceps/soleus edzés és nyújtás javasolt.",
    "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hipertónia: bal m. quadriceps. Gyengeség: m. gluteus maximus és hamstring. Farizom/hátsó lánc edzés és nyújtás javasolt.",
    "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hipertónia: jobb hamstring és m. popliteus. Gyengeség: m. quadriceps és soleus. Quadriceps/soleus edzés és nyújtás javasolt.",
    "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hipertónia: jobb m. quadriceps. Gyengeség: m. gluteus maximus és hamstring. Farizom/hátsó lánc edzés és nyújtás javasolt.",
    "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Enyhe gerinceltérés. Figyeljen a tartásra és erősítse a törzsizmokat.",
    "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Mérsékelt gerinceltérés. Szakértői edzés javasolt.",
    "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hipertónia: jobb felső trapéz. Gyengeség: középső/alsó trapéz. Edzés (középső/alsó) és lazítás javasolt.",
  "neckReport": {
  "title": "Nyaki funkció",
  "conclusion": "Nyakfunkció értékelése",
  "loading": "A jelentés készül. Kérjük, várjon.",
  "failed": "A jelentés összeállítása sikertelen volt",
  "analysis": "Elemzés",
  "suggestion": "Javaslat",
  "suggestionText": "Forduljon szakemberhez a pontos ok feltárásához és kezeléséhez"
}
}
